import { useId } from "react";
import potionBannerSrc from "../assets/banderole_potion.svg";


function bannerFontSize(name) {
  const length = String(name || "").length;
  if (length > 24) return 27;
  if (length > 20) return 30;
  if (length > 16) return 33;
  return 36;
}

export default function PotionBannerTitle({ name }) {
  const rawId = useId().replace(/:/g, "");
  const pathId = `potion-banner-curve-${rawId}`;
  const label = String(name || "").trim();

  return (
    <div className="potion-card__banner" aria-hidden="true">
      <img
        src={potionBannerSrc}
        alt=""
        className="potion-card__banner-art"
        draggable={false}
      />
      <svg
        className="potion-card__banner-svg"
        viewBox="0 0 384 168"
        preserveAspectRatio="xMidYMid meet"
        overflow="visible"
      >
        <defs>
          <path
            id={pathId}
            d="M 74 84 C 140 22, 244 22, 310 84"
            fill="none"
          />
        </defs>
        {label ? (
          <text
            className="potion-card__banner-label"
            fontSize={bannerFontSize(label)}
            textAnchor="middle"
          >
            <textPath href={`#${pathId}`} startOffset="50%">
              {label}
            </textPath>
          </text>
        ) : null}
      </svg>
    </div>
  );
}

